import React from 'react';

import { mui } from '../libs';
import { FONT_SIZE } from '../theme/layout-size';

/**
 * Styled TreeItem component with custom styling for tree nodes
 */
const TreeItemComp = mui.styles.styled(mui.TreeItem)({
  borderRadius: '4px',
  background: 'none!important',
  padding: '0!important',
  '&:hover': {
    background: 'none!important',
  },
  '& .MuiTreeItem-label': {
    fontWeight: '500 !important',
    fontSize: `${FONT_SIZE.xs}!important`,
    padding: '2px',
  },
  '& .MuiTreeItem-content': {
    padding: '0!important',
    '&:hover': {
      background: 'none!important',
    },
  },
  '& .Mui-selected': {
    background: 'none!important',
  },
});

type FinTreeItemProps = {
  /** Child nodes to render under this tree item */
  children?: React.ReactNode;
  /** Label content to display for this tree item */
  label: React.ReactElement;
  /** Unique ID for this tree node */
  nodeId: string;
  /** Optional custom styles to apply */
  sx?: Record<string, React.CSSProperties>;
};

/**
 * Component that renders a customized tree item node with consistent styling
 *
 * @param children - Child nodes to render under this tree item
 * @param label - Label content to display for this tree item
 * @param nodeId - Unique ID for this tree node
 * @param sx - Optional custom styles to apply
 * @returns Rendered tree item component
 */
const FinTreeItem = ({ children, label, nodeId, sx }: FinTreeItemProps) => (
  <TreeItemComp label={label} nodeId={nodeId} sx={sx}>
    {children}
  </TreeItemComp>
);

export default FinTreeItem;
